import { render } from "./AnswersMobileSlider.vue?vue&type=template&id=693ea4be&scoped=true"
import script from "./AnswersMobileSlider.vue?vue&type=script&lang=js"
export * from "./AnswersMobileSlider.vue?vue&type=script&lang=js"

import "./AnswersMobileSlider.vue?vue&type=style&index=0&id=693ea4be&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Anael\\Documents\\developpement\\teachup-video-interactive\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-693ea4be"]])

export default __exports__